import { Flex, Group } from "@mantine/core";

import { IconLanguage } from "@tabler/icons-react";

import { TextWrapper } from "@/components/TextWrapper";

export default function ClientInterpreterCard({
  required,
  languages,
}: {
  required: boolean;
  languages: string;
}) {
  if (!required) {
    return null;
  }

  return (
    <Flex py={6} px={24} bg="red.1" justify="flex-start">
      <Group gap="xs" align="flex-start">
        <IconLanguage size={20} color="var(--mantine-color-red-9)" />
        <TextWrapper fz="sm" c="red.9" variant="default">
          Interpreter Required
        </TextWrapper>
        <TextWrapper fz="sm" c="red.9" variant="bold">
          {languages}
        </TextWrapper>
      </Group>
    </Flex>
  );
}
